// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var CustomerEditController = function ($rootScope,
    $scope,
    $location,
    $routeParams,
    $modal,
    Customer,
    CountryList,
    CountryStates,
    CountryWhiteListSettings,
    CustomFieldSettings,
    gettext,
    gettextCatalog,
    GeneralEmailSettings,
    InvoiceAttachmentDisplayFormats,
    DatepickerUtils) {
    
    $scope.locale = gettextCatalog.currentLanguage.toUpperCase();
    $scope.countries = [];
    $scope.states = [];
    $scope.displayedCountries = [];
    $scope.CountryWhiteListSettings = {};
    $scope.selectedInvoiceAttachmentFormat = null;
    $scope.zugFerdFeature = "ZugferdV1";
    $scope.minBirthDate = "1900-01-01";
    
    $scope.availableInvoiceAttachmentFormats = null;
    $scope.emailBearerMediumAsDefault = false;
    $scope.tooltips = Object.freeze({
        "BuyerReference": gettext("The \"Buyer reference\" (Leitweg-ID in Germany) is used to identify the Invoice recipient. The \"Buyer reference\" will be transmitted in every XML in the field ‘Buyer reference’ (BT-10)."),
        "ZugferdStandard": gettext("The selected ZUGFeRD Standard will overwrite the global ZUGFeRD settings (only in case when Zugferd standard selected)"),
        "CountryWhitelist": gettext("The country in the address field does not match one of the countries in the whitelist. Customers that existed before the whitelist was set up can still be updated without changing the country."),
        "AdditionalEmails": gettext("All emails that are sent to the primary email are sent to the additional email addresses. That includes invoices, credit notes, reminders, user notifications and prenotification emails."),
        "AdditionalAddresses": gettext("You can add additional addresses here and then use them as the shipping address for any contract. You can add up to 5 additional addresses.")
    });

    $scope.DefaultBearerMediumValues = Object.freeze({
        Email: "Email",
        Archive: "ArchiveOnly",
        SnailMail: "SnailMail",
        EInvoicing: "EInvoicing"
    })
    
    if ($routeParams.customerId) {
        $scope.IsExistingCustomer = true;
        $scope.customer = Customer.get({customerId: $routeParams.customerId},
            function (data) {
                if (!$scope.customer.CustomFields) {
                    $scope.customer.CustomFields = {};
                }

                if (data.DefaultBearerMedium === $scope.DefaultBearerMediumValues.Email) {
                    $scope.emailBearerMediumAsDefault = true;
                }

                GeneralEmailSettings.get({ }, function (generalData) {
                    $scope.getSelectedInvoiceAttachmentFormat(generalData.InvoiceAttachmentFormat, data.InvoiceAttachmentFormat);
                    $scope.generalInvoiceFormat = generalData.InvoiceAttachmentFormat;
                    $scope.eInvoicingNetworks = generalData.EInvoicingNetworks;
                    if(!$scope.eInvoicingNetworks.some(x => x.NetworkId === data.EInvoicingNetworkId))
                        $scope.customer.EInvoicingNetworkId = '';
                });
                if (!data.AdditionalAddresses){
                    data.AdditionalAddresses = [];
                }
            });
        if (!$scope.customer.AdditionalEmailAddresses) {
            $scope.customer.AdditionalEmailAddresses = [];
        }
        if (!$scope.customer.AdditionalAddresses) {
            $scope.customer.AdditionalAddresses = [];
        }
    }
    else {
        $scope.IsExistingCustomer = false;
        $scope.customer = new Customer();
        $scope.customer.DefaultBearerMedium = $scope.DefaultBearerMediumValues.Archive;
        $scope.customer.CustomFields = {};
        $scope.customer.AdditionalEmailAddresses = [];
        $scope.customer.AdditionalAddresses = [];

        GeneralEmailSettings.get({}, function (data) {
            $scope.getSelectedInvoiceAttachmentFormat(data.InvoiceAttachmentFormat, null);
            $scope.generalInvoiceFormat = data.InvoiceAttachmentFormat;
            $scope.eInvoicingNetworks = data.EInvoicingNetworks;
            if($scope.eInvoicingNetworks.length === 1)
                $scope.customer.EInvoicingNetworkId = $scope.eInvoicingNetworks[0].NetworkId;
        });
    }

    loadCountries();

    CustomFieldSettings.get({},
        function (data) {
            $scope.customFieldSettings = data.CustomFieldDescriptors;
        });

    $scope.getSelectedInvoiceAttachmentFormat = function (generalFormat, customerFormat) {
        if ($scope.features[$scope.zugFerdFeature]) {
            $scope.availableInvoiceAttachmentFormats = InvoiceAttachmentDisplayFormats.getFormats();
            if (customerFormat) {
                $scope.selectedInvoiceAttachmentFormat = customerFormat;
                $scope.zugFerdStandardSwitch = true;
            } else {
                $scope.selectedInvoiceAttachmentFormat = generalFormat;
                $scope.zugFerdStandardSwitch = false;
            }
        }
    };

    $scope.canShowBuyerReference = function(isZugFerdActive, showEInvoiceFields) {
        let invoiceAttachmentDisplayFormat = $scope.selectedInvoiceAttachmentFormat
            ? $scope.selectedInvoiceAttachmentFormat
            : $scope.generalInvoiceFormat;
        return Customer.canShowBuyerReference(isZugFerdActive, invoiceAttachmentDisplayFormat, showEInvoiceFields);
    };

    function finish() {
        $location.path("/customers/" + $scope.customer.Id);
    }

    $scope.setZugFerdStandard = function(isSwitchedOn) {
        $scope.zugFerdStandardSwitch = isSwitchedOn;
    }

    $scope.save = function () {
        if ($scope.features[$scope.zugFerdFeature]) {
            $scope.customer.InvoiceAttachmentFormat =
                $scope.zugFerdStandardSwitch === true ? $scope.selectedInvoiceAttachmentFormat : null;
        }
        if ($scope.customer.BirthDate) {
            $scope.customer.BirthDate = DatepickerUtils.backToBrowserTimezone($scope.customer.BirthDate);
            $scope.customer.BirthDate = DatepickerUtils.toShortBerlinDateString($scope.customer.BirthDate);
        }
        if (!$rootScope.isValid($scope.form))
            return;
        if ($routeParams.customerId)
            $scope.customer.$update({ customerId: $routeParams.customerId }, finish);
        else
            $scope.customer.$save({}, finish);
    };

    $scope.dataValid = function () {
        if($scope.form.vatId) {
            return !$scope.form.vatId.$invalid;
        }
    };

    $scope.$watch('customer.Address.Country', function () {
        if ($scope.customer != null && $scope.customer.Address != null && $scope.customer.Address.Country != null) {
            loadStates($scope.customer.Address.Country);
        }
    });

    $scope.isEmptyEmail = function () {
        return !$scope.customer.EmailAddress;
    }

    $scope.isEmptyAddress = function () {
        return !$scope.customer.Address || !$scope.customer.Address.City || !$scope.customer.Address.Country || !$scope.customer.Address.PostalCode;
    }

    $scope.isEmptyEInvoicing = function () {
        return !$scope.customer.EInvoicingId || !$scope.customer.EInvoicingNetworkId || !$scope.customer.BuyerReference;
    }

    $scope.$watch('customer.EmailAddress', function () {
        if ($scope.emailBearerMediumAsDefault) {
            if ($scope.isEmptyEmail()) {
                $scope.customer.DefaultBearerMedium = $scope.DefaultBearerMediumValues.Archive;
            } else {
                $scope.customer.DefaultBearerMedium = $scope.DefaultBearerMediumValues.Email;
            }
        }
    })

    $scope.setModeOfDispatch = function(modeOfDispatch){
        if (modeOfDispatch === $scope.DefaultBearerMediumValues.Email) {
            $scope.customer.DefaultBearerMedium = modeOfDispatch;
            $scope.emailBearerMediumAsDefault = true;
        } else {
            $scope.customer.DefaultBearerMedium = modeOfDispatch;
            $scope.emailBearerMediumAsDefault = false;
        }
    }

    $scope.$watch('customer.Address', function() {
        if ($scope.customer.DefaultBearerMedium === $scope.DefaultBearerMediumValues.SnailMail && $scope.isEmptyAddress()) {
            $scope.customer.DefaultBearerMedium = $scope.DefaultBearerMediumValues.Archive;
        }
    })

    let revertDispatchToArchive = function() {
        if ($scope.customer.DefaultBearerMedium === $scope.DefaultBearerMediumValues.EInvoicing && $scope.isEmptyEInvoicing()) {
            $scope.customer.DefaultBearerMedium = $scope.DefaultBearerMediumValues.Archive;
        }
    }

    $scope.$watch('customer.EInvoicingId', revertDispatchToArchive);
    $scope.$watch('customer.BuyerReference', revertDispatchToArchive);

    $scope.IsDispatchModeEInvoicing = function() {
        return $scope.customer.DefaultBearerMedium === $scope.DefaultBearerMediumValues.EInvoicing;
    }

    $scope.addAdditionalEmailAddress = function () {
        if ($scope.canAddAdditionalEmailAddress()) {
            $scope.customer.AdditionalEmailAddresses.push({});
        }
    }

    $scope.removeAdditionalEmailAddress = function (assignment) {
        $scope.customer.AdditionalEmailAddresses = $scope.customer.AdditionalEmailAddresses.filter(function (_) { return _ !== assignment });
    }

    function distinct(value, index, self) {
        return !!value.EmailAddress && value.EmailAddress !== $scope.customer.EmailAddress && self.findIndex(function (_) { return _.EmailAddress === value.EmailAddress }) === index;
    }

    $scope.cleanupAdditionalEmailAddresses = function () {
        $scope.customer.AdditionalEmailAddresses = $scope.customer.AdditionalEmailAddresses.filter(distinct);
    }

    $scope.canAddAdditionalEmailAddress = function () {
        return $scope.customer.AdditionalEmailAddresses.length < 5;
    }

    $scope.canAddAdditionalAddress = function () {
        return $scope.customer.AdditionalAddresses.length < 5;
    }

    $scope.cancel = function () { $location.path("/customers"); };

    function loadCountries() {
        CountryList.getCountries().then(function (response) {
                $scope.countries = response.data.slice();
                loadWhiteListCountries()
            },
            function () {
                $scope.notify("error", gettextCatalog.getString(gettext('An error occurred')));
            });
    }

    function loadStates(country) {
        CountryStates.getStates(country).then(function (response) {
            $scope.states = response.data.slice();
            if (!$scope.states.length) {
                $scope.customer.Address.State = null;
            }
        },
            function () {
                $scope.notify("error", gettextCatalog.getString(gettext('An error occurred')));
            });
    }

    function loadWhiteListCountries() {
        CountryWhiteListSettings.get($scope.locale).then(function (response) {
            $scope.CountryWhiteListSettings = response.data;
            if ($scope.CountryWhiteListSettings.IsEnabled) {
                setDisplayedCountries();
                if (!$scope.isCustomerCountryInWhiteList($scope.customer.Address.Country)) {
                    let customerCountry = $scope.countries.find(function (countryCode) {
                        return countryCode.TwoLetterCode === $scope.customer.Address.Country;
                    });
                    $scope.displayedCountries.push(customerCountry);
                }
            } else {
                $scope.displayedCountries = $scope.countries;
            }
        }, function () {
            $scope.notify("error", gettextCatalog.getString(gettext('An error occurred')));
        });
    }

    function setDisplayedCountries() {
        let availableCountries = $scope.countries.filter(function (country) {
            return $scope.CountryWhiteListSettings.CountryWhiteList.some(function (countryFromWhitelist) {
                return country.TwoLetterCode === countryFromWhitelist.TwoLetterCode && country.TwoLetterCode;
            });
        });
        $scope.displayedCountries = $scope.displayedCountries.concat(availableCountries);
    }

    $scope.isCustomerCountryInWhiteList = function (currentCountry) {
        if (!$scope.IsExistingCustomer && $scope.CountryWhiteListSettings.IsEnabled) {
            return true;
        } else if ($scope.CountryWhiteListSettings.CountryWhiteList && $scope.CountryWhiteListSettings.IsEnabled && $scope.IsExistingCustomer) {
            return $scope.CountryWhiteListSettings.CountryWhiteList.find(function (countryCode) {
                return countryCode.TwoLetterCode === currentCountry && $scope.CountryWhiteListSettings.IsEnabled;
            });
        }
        return true;
    }

    $scope.showEInvoiceFields = function (){
        return $scope.features && $scope.features["EInvoicingEcosio"] && $scope.eInvoicingNetworks && $scope.eInvoicingNetworks.length > 0;
    }

    $scope.isEInvoiceNetworkDisabled = function(){
        return $scope.eInvoicingNetworks && $scope.eInvoicingNetworks.length === 1 && $scope.eInvoicingNetworks[0].NetworkId === $scope.customer.EInvoicingNetworkId;
    }

    $scope.addEditAdditionalAddress = function (additionalAddress) {
        var item = additionalAddress ? additionalAddress : {};
        var modalInstance = $modal.open({
            templateUrl: '/partials/controls/additional-address-dialog.html' + itero.linkVersion,
            controller: AdditionalAddressController,
            windowClass: "fade in",
            resolve: {
                CustomerId: function () {
                    return null;
                },
                AdditionalAddresses: function () {
                    return null;
                },
                AdditionalAddress: function () {
                    return item;
                },
                CountryWhiteListSettings: function () {
                    return $scope.CountryWhiteListSettings;
                },
                IsExistingCustomer : function (){
                    return $scope.IsExistingCustomer;
                },
                DisplayedCountries: function (){
                    return $scope.displayedCountries;
                }
            }
        });

        modalInstance.result.then(function (result) {
            if (result) {
                if (!additionalAddress) $scope.customer.AdditionalAddresses.push(item);
                Object.assign(item, result);
            }
        });
    };
    
    $scope.getAdditionalAddressFormat = function (additionalAddress){
        const array = [];
        if(additionalAddress.Street) {
            var text = additionalAddress.Street;
            if (additionalAddress.HouseNumber) {
                text += " " + additionalAddress.HouseNumber;
            }
            array.push(text);
        }
        if(additionalAddress.PostalCode) array.push(additionalAddress.PostalCode);
        if(additionalAddress.City) array.push(additionalAddress.City);
        if(additionalAddress.Country) array.push(additionalAddress.Country);
        return array.join(", ");
    }

    $scope.removeAdditionalAddress = function (additionalAddress) {
        $scope.yesCancel(gettextCatalog.getString(gettext('Delete Additional Address')),
            gettextCatalog.getString(gettext('Are you sure?')),
            function () {
                $scope.customer.AdditionalAddresses = $scope.customer.AdditionalAddresses.filter(function (_) {
                    return _ !== additionalAddress
                });
            });
    }

    $scope.getMaxBirthDate = function() {
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        return yesterday.toISOString().split('T')[0];
    };
    
};
CustomerEditController.$inject = [
    '$rootScope', '$scope', '$location', '$routeParams', '$uibModal', 'Customer', 'CountryList', 'CountryStates', 'CountryWhiteListSettings',
    'CustomFieldSettings', 'gettext', 'gettextCatalog', 'GeneralEmailSettings', 'InvoiceAttachmentDisplayFormats', 'DatepickerUtils'
];
